import { Chip, makeStyles, Typography } from "@material-ui/core";
import get from "lodash/get";
import React from "react";

interface ICustomArrayChipField {
  source: string;
  chipSource: string;
  record?: object;
  label?: string;
}

const useStyles = makeStyles({
  root: {
    padding: "6px 0 4px",
    "& .MuiChip-root": {
      marginLeft: 8,
    },
  },
});

const CustomArrayChipField = ({
  source,
  chipSource,
  record = {},
}: ICustomArrayChipField) => {
  const classes = useStyles();
  const datas = get(record, source);

  return (
    <>
      {datas && (
        <>
          {datas.length === 0 ? (
            <Typography>-</Typography>
          ) : (
            <div className={classes.root}>
              {datas.map((data: any, key: number) => (
                <Chip key={key} label={data[chipSource]} />
              ))}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default CustomArrayChipField;
